// Supported CAD/3D file formats across the app (case publication + deliverables).
export const CAD_EXTS = ["stl", "ply", "obj"];
export const CAD_ACCEPT = ".stl,.ply,.obj";

export function extOf(name = "") {
  const m = /\.([a-z0-9]+)$/i.exec(name);
  return m ? m[1].toLowerCase() : "";
}

export function isCadFile(nameOrFile) {
  const name = typeof nameOrFile === "string" ? nameOrFile : nameOrFile?.name || "";
  return CAD_EXTS.includes(extOf(name));
}

// Normalized list of CAD files for a case (new multi-file field + legacy stlUrl fallback).
export function getCaseCadFiles(caseItem) {
  if (Array.isArray(caseItem?.cadFiles) && caseItem.cadFiles.length) return caseItem.cadFiles;
  if (caseItem?.stlUrl) return [{ url: caseItem.stlUrl, name: caseItem.stlName || "model.stl" }];
  return [];
}
